Application.Postcard.Icon = {
    ui: {
        container: '.js-postcard-icon',
        previewContent: '.js-postcard-icon__preview-content',
        previewIcon: '.js-postcard-icon__preview-icon',
        inputSvg: '.js-postcard-icon__input-svg'
    },
    previewList: null,
    svgIcon: null,
    current: null,
    ready: function (previewList) {

        if (!$(this.ui.container).length){
            return;
        }

        // assign
        this.previewList = previewList;

        // child modules
        this.Greeting.ready(previewList);

        // bind handlers
        this.bind();

        // create icon
        this.svgIcon = new Application.SvgIcon();
        $(this.ui.previewIcon).empty().append(this.svgIcon.element);

    },
    bind: function(){

        var self = this;

        this.previewList.setOnChange(function(id, src, data){
            self.icon(id, src, data.previewWidthRatio, data.x, data.isPng);
        });
        this.previewList.setOnReset(function(){
            self.icon(self.current.id, self.current.src, self.current.ratio, self.current.x, self.current.isPng);
        });

    },
    icon: function(id, src, ratio, x, isPng){

        var self = this;

        // save
        this.current = {id: id, src: src, ratio: ratio, x: x, isPng: isPng};

        // change size
        $(this.ui.previewIcon).css('width', (ratio * $(this.ui.previewIcon).data('width')) + 'em');
        // set x position
        $(this.ui.previewIcon).css('margin-left', (x * $(this.ui.previewIcon).data('width')) + 'em');

        // change icon
        if (isPng){
            this.svgIcon.setPng(src, Application.SvgIcon.FIT_WIDTH, function(){
                // mark as ready
                $(self.ui.container).removeClass('step-preview_loading');
                // update input
                self.updateInput();
            });
        }else{
            this.svgIcon.setIcon(src, $(this.ui.previewIcon).attr('data-color'), Application.SvgIcon.FIT_WIDTH, function(){
                // mark as ready
                $(self.ui.container).removeClass('step-preview_loading');
                // update input
                self.updateInput();
            });
        }

    },
    updateInput: function(){

        $(this.ui.inputSvg).val(this.svgIcon.getSvg());

    }
};